var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"app",attrs:{"dark":_vm.appConfig.dark}},[_c('app-parallax'),_vm._v(" "),(_vm.$route.fullPath !== '/')?_c('app-top'):_vm._e(),_vm._v(" "),_c('router-view',{staticClass:"app__router",class:{'app__router--small':_vm.appConfig.small}}),_vm._v(" "),_c('footerCompanyFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a1799ff","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 